<template>
   <div v-font-color-contrast class="powered">
      <span>powered by</span>
      <NxtLogo :module-key="ModuleKey.NxtForm" mode="light" height="16" />
   </div>
</template>

<script setup lang="ts">
import { NxtLogo } from '@nxtpeople/nxt-styles';
import { ModuleKey } from '@nxtpeople/nxt-vue-library';
</script>

<style lang="scss" scoped>
.powered {
   position: relative;
   padding: var(--nxt-gutter-small);
   font-size: toRem(8);
   display: flex;
   flex-direction: column;
   align-items: center;
   justify-content: center;
   gap: calc(var(--nxt-gutter-small) / 4);
   padding-top: var(--nxt-gutter-large);
}
</style>

